import * as consts from '@/constants';

export default {
  dataAgeRangesStatus: consts.REQUEST_WITHOUT_STARTING,
  age_ranges: [],
};
